<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">Ranking</div>
      <div slot="sub-title">Tabla de Posiciones de la Escuela</div>
      <div slot="right">
        <div class="columns">
          <div class="column is-full">
            <filters :selected-lesson.sync="lessonSelect" :selected-from-date.sync="selectedFromDate" :selected-to-date.sync="selectedToDate"/>
          </div>
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div class="columns">
        <div class="column">
          <card-component title="Tabla de Posiciones" :subtitle="subtitle" class="has-table has-mobile-sort-spaced" :header-search-input="false">
            <div slot="headerRight" class="card-header-icon">
              <b-button type="is-link" class="is-pulled-right" @click="exportRankingPDF" :loading="isDownloading">
                <b-icon
                    icon="file-download"></b-icon>
              </b-button>
            </div>
            <b-tabs slot="content" v-model="activeTab">
              <b-tab-item label="Ranking General">
                  <ranking-table  @number-result-changed="rankingLength = $event" :lesson-id="lessonSelect" :from-date="selectedFromDate" :to-date="selectedToDate"/>
              </b-tab-item>
              <b-tab-item label="Ranking Jinetes">
                <ranking-riders-table @number-result-changed="ridersRankingLength = $event" :lesson-id="lessonSelect" :from-date="selectedFromDate" :to-date="selectedToDate"/>
              </b-tab-item>
              <b-tab-item label="Ranking Caballos">
                <ranking-horses-table  @number-result-changed="horseRankingLength = $event" :lesson-id="lessonSelect" :from-date="selectedFromDate" :to-date="selectedToDate"/>
              </b-tab-item>
            </b-tabs>
          </card-component>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RankingService from '@/services/RankingService'

import HeroBar from '@/components/HeroBar'
import Filters from '@/components/Filters'
import CardComponent from '@/components/CardComponent'
import RankingTable from './components/RankingTable'
import RankingHorsesTable from './components/RankingHorsesTable'
import RankingRidersTable from './components/RankingRidersTable'
import RankingFilterService from '@/services/filters/RankingFilterService'

export default {
  components: {
    HeroBar,
    Filters,
    CardComponent,
    RankingTable,
    RankingHorsesTable,
    RankingRidersTable
  },
  created () {
    this.initFilters()
  },
  data () {
    return {
      activeTab: 0,
      lessonSelect: 0,
      selectedFromDate: null,
      selectedToDate: null,
      isDownloading: false,
      rankingLength: 0,
      ridersRankingLength: 0,
      horseRankingLength: 0
    }
  },
  methods: {
    initFilters () {
      let filters = RankingFilterService.getFilters(this.$route.query)
      this.selectedFromDate = filters.from
      this.selectedToDate = filters.to
      this.lessonSelect = filters.lesson
      this.updateParams()
    },
    getFormatedFilters () {
      let filters = {
        from: this.fromFormated,
        to: this.toFormated,
        lesson: this.lessonSelect
      }
      return filters
    },
    updateParams () {
      let formatedFilters = this.getFormatedFilters()
      RankingFilterService.setStorageFilters(formatedFilters)
      // eslint-disable-next-line handle-callback-err
      this.$router.replace({ query: formatedFilters }).catch(err => {})
    },
    async exportRankingPDF () {
      this.isDownloading = true
      this.openAlert()
      let params = {
        from: this.fromFormated,
        to: this.toFormated,
        'lessons[0]': this.lessonSelect === 0 ? null : this.lessonSelect
      }

      let response = null

      switch (this.activeTab) {
        case 0:
          response = await RankingService.exportRanking(params)
          break
        case 1:
          response = await RankingService.exportRankingRiders(params)
          break
        case 2:
          response = await RankingService.exportRankingHorses(params)
          break
        default:
          break
      }

      if (response) {
        let blob = new Blob([response.data], { type: 'application/pdf' })
        var fileURL = window.URL.createObjectURL(blob)
        var fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', `Resultados Escuela ${this.$moment().format('LL')}.pdf`)
        document.body.appendChild(fileLink)
        fileLink.click()
      }
      this.isDownloading = false
    },
    openAlert () {
      this.$buefy.notification.open({
        duration: 4000,
        icon: 'account',
        message: `<icon class="mdi mdi-24px mdi-download"></icon> La descarga comenzará dentro de poco`,
        position: 'is-bottom-left',
        type: 'is-info',
        hasIcon: false
      })
    }
  },
  watch: {
    selectedFromDate () {
      this.updateParams()
    },
    selectedToDate () {
      this.updateParams()
    },
    lessonSelect () {
      this.updateParams()
    }
  },
  computed: {
    fromFormated () {
      return this.$moment(this.selectedFromDate).format('YYYY-MM-DD')
    },
    toFormated () {
      return this.$moment(this.selectedToDate).format('YYYY-MM-DD')
    },
    subtitle () {
      let subtitle
      let text
      if (this.activeTab === 0) {
        text = this.rankingLength === 1 ? 'posición en el ranking general' : 'posiciones en el ranking general'
        subtitle = `${this.rankingLength} ${text}`
      } else if (this.activeTab === 1) {
        text = this.ridersRankingLength === 1 ? 'posición en el ranking de jinetes' : 'posiciones en el ranking de jinetes'
        subtitle = `${this.ridersRankingLength} ${text}`
      } else if (this.activeTab === 2) {
        text = this.horseRankingLength === 1 ? 'posición en el ranking de caballos' : 'posiciones en el ranking de caballos'
        subtitle = `${this.horseRankingLength} ${text}`
      }
      return subtitle
    }
  }
}
</script>
